import type { ReactNode } from 'react';
import { contactLabel, type Contact } from '~/utils/contact';

type ContactCheckboxListProps<T extends Contact> = {
  contacts: T[];
  selectedContactIds: Set<string>;
  onToggle: (contact: T) => void;
  checkboxIdPrefix: string;
  itemClassName?: string;
  isDisabled?: (contactId: string) => boolean;
  trailing?: (contact: T) => ReactNode;
};

const NEVER_DISABLED = () => false;
const NO_TRAILING = () => null;

export function ContactCheckboxList<T extends Contact>({
  contacts,
  selectedContactIds,
  onToggle,
  checkboxIdPrefix,
  itemClassName = 'px-1 py-2 flex items-center gap-2',
  isDisabled = NEVER_DISABLED,
  trailing = NO_TRAILING,
}: Readonly<ContactCheckboxListProps<T>>) {
  return (
    <>
      {contacts.map((contact) => {
        const checkboxId = `${checkboxIdPrefix}-${contact.id}`;
        return (
          <li key={contact.id} className={itemClassName}>
            <input
              id={checkboxId}
              type="checkbox"
              className="h-4 w-4 cursor-pointer disabled:cursor-not-allowed"
              checked={selectedContactIds.has(contact.id)}
              disabled={isDisabled(contact.id)}
              onChange={() => onToggle(contact)}
            />
            <label
              htmlFor={checkboxId}
              className="text-sm w-full min-w-0 truncate cursor-pointer"
            >
              {contactLabel(contact)}
            </label>
            {trailing(contact)}
          </li>
        );
      })}
    </>
  );
}
